"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * InodePilot documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 4.4.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingControllerV2Api = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class LoggingControllerV2Api extends runtime.BaseAPI {
    /**
     */
    writeToLogRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.LoggingRequest === null ||
                requestParameters.LoggingRequest === undefined) {
                throw new runtime.RequiredError("LoggingRequest", "Required parameter requestParameters.LoggingRequest was null or undefined when calling writeToLog.");
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters["Content-Type"] = "application/json";
            const response = yield this.request({
                path: `/v2/log/write`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.LoggingRequestToJSON)(requestParameters.LoggingRequest),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    writeToLog(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.writeToLogRaw(requestParameters, initOverrides);
        });
    }
}
exports.LoggingControllerV2Api = LoggingControllerV2Api;
